import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'forms-url-attribute',
  templateUrl: './url-attribute.component.html',
  styleUrls: ['./url-attribute.component.scss'],
})
export class UrlAttributeComponent {
  @Input() control: UntypedFormControl;
  @Input() controlID: string;
  @Input() displayName: string;
  urlText: string;

  @Output() cleared = new EventEmitter<string>();

  clearAttrib() {
    this.cleared.emit(this.controlID);
  }
}
